import { render, staticRenderFns } from "./FlightOrderSummary.vue?vue&type=template&id=1e1e9656&scoped=true&"
import script from "./FlightOrderSummary.vue?vue&type=script&lang=js&"
export * from "./FlightOrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./FlightOrderSummary.vue?vue&type=style&index=0&id=1e1e9656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e9656",
  null
  
)

/* custom blocks */
import block0 from "./FlightOrderSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
